<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Bulk Update Users</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <div class="modal-card-body">
          <div class="field">
            <label class="label">User Status</label>
            <v-select
              :options="statusOptions"
              item-text="name"
              item-value="value"
              v-model="status.updated"
            />
          </div>

          <div class="field">
            <label class="label">User Permission Policy</label>
            <v-select
              v-if="policies.length > 0"
              :options="policies"
              item-text="name"
              item-value="id"
              v-model="policy.updated"
            />
          </div>
        </div>

        <footer class="modal-card-foot">
          <button 
            :disabled="(!policy && !status) || !updatedAttrs || updating"
            :class="{ 'is-loading': updating }"
            class="button is-primary" 
            @click.stop="bulkUpdate()">
            Confirm Bulk Update
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

import VSelect from '@/components/base/VSelect'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { VSelect },
  data() {
    return {
      policy: {
        default: null,
        updated: null
      },
      status: {
        default: null,
        updated: null
      },
      updating: false
    }
  },
  computed: {
    ...mapState("users", [
      "users", "statusOptions", "selected"
    ]),
    ...mapGetters("users", ["selectedUsers"]),
    ...mapState("permissions", ["policies"]),
    updatedAttrs({ policy, status }) {
      return policy.default != policy.updated || status.default != status.updated
    }
  },
  watch: {
    value(v) {
      if (v) {
        const { selectedUsers } = this;
        let statusesEqual = selectedUsers.map(d => d.is_active)
          .every((val, i, arr) => val === arr[0]);

        let policiesEqual = selectedUsers.map(d => d.policy ? d.policy.id : null)
          .every((val, i, arr) => val === arr[0]);

        if (statusesEqual) {
          this.status.default = selectedUsers[0].is_active;
          this.status.updated = selectedUsers[0].is_active;
        }

        if (policiesEqual) {
          this.policy.default = selectedUsers[0].policy.id;
          this.policy.updated = selectedUsers[0].policy.id;
        }
      }
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("users", ["updateUser"]),
    ...mapActions("permissions", ["getPolicies", "setUserPolicy"]),
    ...mapMutations("app", ["setNotification"]),
    initialize() {
      if (this.policies.length == 0) {
        this.getPolicies();
      }
    },
    bulkUpdate() {
      const { policy, status, selected, users } = this;
      let promises = [];

      this.updating = true;

      if (policy) {
        let policyObj = this.policies.filter(d => d.id == policy.updated);
        promises.push(
          this.setUserPolicy({ policyId: policy.updated, data: { user_ids: selected } })
            .then(() => { 
              selected.forEach(userId => {
                let user = Object.assign({}, users.filter(d => d.id == userId));
                user.policy = policyObj;
                this.updateUser({ id: userId, data: user }); 
              })
            })
        )
      }

      if (status) {
        this.selected.forEach(id => {
          promises.push(this.updateUser(
            { id: id, data: { is_active: status.updated } })
          )
        }) 
      }

      Promise.all(promises).then(() => {
        this.setNotification({
          status: true,
          message: 'Bulk update successfully completed',
          type: 'success'
        })

        this.updating = false;
        this.close(true);
      }).catch(() => {
        this.updating = false;
      })
      
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
